import { createSelector } from 'reselect'

export const selectTutorial = (state) => state.tutorial

export const selectTutorials = createSelector(
  selectTutorial,
  (tutorial) => tutorial.tutorials
)